import { createStyles, makeStyles } from "@material-ui/core/styles";
import React from "react";

import { Chip, RelodeTheme } from "..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            chip: {
                width: "100%",
                minHeight: 40,
                borderRadius: 32,
                justifyContent: "flex-start",
            },
        }),
    { name: "selectChips" }
);

export interface SelectChip {
    chipId: number;
    label: string;
    selected: boolean;
}

interface SelectChipsProps {
    onChange: (chipId: number) => void;
    values: SelectChip[];
    id: string;
}

export const SelectChips = (props: SelectChipsProps) => {
    const classes = useStyles(props);

    return (
        <>
            {props.values.map(x => (
                    <Chip
                        id={`${props.id}-select-${x.chipId}`}
                        key={x.chipId}
                        value={x.selected}
                        className={classes.chip}
                        onChipClick={() => props.onChange(x.chipId)}
                        selected={x.selected === true}
                        label={x.label}
                        dataCy={`select-option-${x.chipId}-chip`}
                    />
                ))}
        </>
    );
};
